import { useState, useEffect } from "react"
import { useDebouncedCallback } from "use-debounce"

const isSticky = (setScrollTop) => {
  const ref = document.getElementById("root")
  const top = ref.scrollTop
  setScrollTop(top)
}
const useRootScrollTop = () => {
  const [scrollTop, setScrollTop] = useState(0)
  const [debounceSetState] = useDebouncedCallback(
    () => isSticky(setScrollTop),
    0
  )
  useEffect(() => {
    const refListner = document
      .getElementById("root")
      .addEventListener("scroll", debounceSetState)
    return document
      .getElementById("root")
      .removeEventListener("scroll", refListner)
  }, [debounceSetState])
  return scrollTop
}

export default useRootScrollTop
